























import { Component, Prop, Vue } from 'vue-property-decorator';
import ICountUp from 'vue-countup-v2';
import { FView } from '@/core/FView';
import { DataType } from '@/core/data/DataType';
import { VisitorsRecord } from '@/core/data/sets/VisitorsRecord';
import { Common } from '@/core/Common';
import { EntranceVisitors } from '@/core/data/sets/computed/EntranceVisitors';
import { EnterExitDailyRecord } from '@/core/data/sets/EnterExitDailyRecord';

@Component ({
  components: {
      ICountUp
  },
})
export default class extends Vue {
    @Prop() dataSet!: EnterExitDailyRecord[];
    countDuration: number = 1.0;

    mostPopularEntrance!: EntranceVisitors;
    mostUnpopularEntrance!: EntranceVisitors;

    created() {
        let dataSet = EntranceVisitors.getEntrancesVisitors(this.dataSet);
        this.mostPopularEntrance = dataSet.reduce((prev, cur) => { return cur.passed > prev.passed ? cur: prev; });
        this.mostUnpopularEntrance = dataSet.reduce((prev, cur) => { return cur.passed < prev.passed ? cur: prev; });
    }
}
